import * as React from 'react';
import { useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  FormControl,
  InputLabel,
  InputBase,
  FormHelperText,
} from '@mui/material';
import { styled } from '@mui/system';
import { Formik } from 'formik';
import { registerSchema } from '../../../../schemas/auth.request';
import { useRegisterMutation } from '../../../../store/api/authApi';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import GoogleLoginBtn from '../../../LoginPage/components/GoogleLoginBtn';

const RegisterInputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '420px',
  height: '510px',
  marginTop: '-6px',
  marginRight: '-7px',
  background: 'rgba(0, 0, 0, 0.5)',

  [theme.breakpoints.down('md')]: {
    width: '400px',
    background: 'transparent',
    marginTop: '0px',
    marginRight: '0px',
  },

  [theme.breakpoints.down('400')]: {
    width: '340px',
    height: '450px',
    background: 'transparent',
    marginTop: '0px',
    marginRight: '0px',
  },
}));

const LoginRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginTop: '34px',
  paddingRight: '60px',

  [theme.breakpoints.down('md')]: {
    paddingRight: '30px',
    marginTop: '20px',
  },

  [theme.breakpoints.down('400')]: {
    paddingRight: '10px',
    marginTop: '20px',
  },

  [theme.breakpoints.down('350')]: {
    paddingRight: '10px',
    marginTop: '15px',
  },
}));

const LoginTypography = styled(Typography)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'rgba(255, 255, 255, 0.7)',
  fontFamily: 'Raleway',
  fontSize: '14px',
  lineHeight: '16px',
  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
    lineHeight: '14px',
  },

  [theme.breakpoints.down('400')]: {
    fontSize: '12px',
    lineHeight: '14px',
  },

  [theme.breakpoints.down('350')]: {
    fontSize: '10px',
    lineHeight: '12px',
  },
}));

const LoginButton = styled(Button)(({ theme }) => ({
  marginLeft: '20px',
  textTransform: 'none',
  color: '#FFFFFF',
  fontFamily: 'Fjalla One',
  backgroundColor: '#000000',
  fontSize: '14px',
  lineHeight: '18px',

  [theme.breakpoints.down('md')]: {
    fontSize: '13px',
    lineHeight: '15px',
  },

  [theme.breakpoints.down('400')]: {
    fontSize: '13px',
    lineHeight: '15px',
  },

  [theme.breakpoints.down('350')]: {
    fontSize: '12px',
    lineHeight: '14px',
    marginLeft: '15px',
  },
}));

const RegisterTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '46px',
  marginTop: '25px',
  color: '#FFFFFF',
  fontFamily: 'Fjalla One',
  fontSize: '20px',
  lineHeight: '25px',

  [theme.breakpoints.down('md')]: {
    //-10px
    marginLeft: '35px',
    marginTop: '25px',
    fontSize: '22px',
    lineHeight: '27px',
  },

  [theme.breakpoints.down('400')]: {
    //-10px
    marginLeft: '35px',
    marginTop: '25px',
    fontSize: '22px',
    lineHeight: '27px',
  },

  [theme.breakpoints.down('350')]: {
    marginLeft: '30px',
    marginTop: '15px',
    marginBottom: '15px',
    fontSize: '18px',
    lineHeight: '20px',
  },
}));

const AuthenticationInputLabel = styled(InputLabel)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '37px',
  marginTop: '38px',
  color: '#FFFFFF',
  fontFamily: 'Raleway',
  fontSize: '16px',
  lineHeight: '16px',

  [theme.breakpoints.down('md')]: {
    marginLeft: '30px',
    marginTop: '37px',
    marginBottom: '37px',
    fontSize: '16px',
    lineHeight: '16px',
  },

  [theme.breakpoints.down('400')]: {
    marginLeft: '30px',
    marginTop: '23px',
    marginBottom: '2px',
    fontSize: '16px',
    lineHeight: '16px',
  },

  [theme.breakpoints.down('350')]: {
    marginTop: '15px',
    marginLeft: '20px',
    fontSize: '12px',
    lineHeight: '12px',
  },
}));

const AuthenticationBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '306px',
  height: '36px',
  marginTop: '50px',
  marginLeft: '46px',

  [theme.breakpoints.down('md')]: {
    marginLeft: '35px',
  },

  [theme.breakpoints.down('400')]: {
    width: '280px',
    height: '40px',
    marginTop: '30px',
    marginLeft: '35px',
  },

  [theme.breakpoints.down('350')]: {
    width: '230px',
    height: '27px',
    marginTop: '20px',
    marginLeft: '30px',
  },
}));

const AuthenticationInput = styled(InputBase)(({ theme }) => ({
  width: '306px',
  background: '#FFFFFF',
  border: '2px solid #AA9178',
  borderRadius: '5px',

  [theme.breakpoints.down('md')]: {
    width: '100%',
    height: '30px',
  },

  [theme.breakpoints.down('400')]: {
    width: '100%',
    height: '30px',
  },

  [theme.breakpoints.down('350')]: {
    width: '100%',
    height: '25px',
  },
}));

const RegisterButton = styled(Button)(({ theme }) => ({
  width: '76px',
  height: '26px',
  textTransform: 'none',
  fontFamily: 'Fjalla One',
  fontSize: '14px',
  lineHeight: '18px',
  marginLeft: '46px',
  marginTop: '20px',
  color: '#FFFFFF',
  backgroundColor: '#AA9178',
  borderRadius: '0',
  [theme.breakpoints.down('md')]: {
    marginLeft: '35px',
    marginTop: '26px',
  },

  [theme.breakpoints.down('400')]: {
    marginLeft: '40px',
    marginTop: '26px',
  },

  [theme.breakpoints.down('350')]: {
    marginLeft: '30px',
    marginTop: '20px',
    height: '24px',
    fontSize: '13px',
    width: '70px',
  },
}));

const ErrorFormHelperText = styled(FormHelperText)(({ theme }) => ({
  width: '306px',
  fontFamily: 'Raleway',

  [theme.breakpoints.down('400')]: {
    //
    width: '280px',
  },

  [theme.breakpoints.down('350')]: {
    //
    width: '220px',
  },
}));

const validateSchema = (values) => {
  const errors = {};
  const valid = registerSchema.validate(values, { abortEarly: false });
  if (valid.error) {
    valid.error.details.forEach((err) => {
      errors[err.path.join('')] = err.message;
    });
  }
  return errors;
};

export default function RegisterInput(props) {
  const [
    register,
    {
      data: registerData,
      isSuccess: isRegisterSuccess,
      isError: isRegisterError,
      error: registerError,
    },
  ] = useRegisterMutation();

  const dispatch = useDispatch();
  useEffect(() => {
    if (isRegisterSuccess) {
      props.handlePageChange('LOGIN');
      toast.success('registered,please sign in.');
    }
    if (isRegisterError && registerError.status === 400) {
      toast.error('user already exist,please sign in.');
    }
  }, [isRegisterSuccess, isRegisterError]);

  const submitForm = async (data) => {
    if (data) {
      await register(data);
    } else {
      toast.error('please fill in all fields!');
    }
  };

  return (
    <RegisterInputContainer>
      <LoginRow>
        <LoginTypography>Already have an account?</LoginTypography>
        <LoginButton onClick={() => props.handlePageChange('LOGIN')}>Login</LoginButton>
      </LoginRow>
      <RegisterTitle>Register your account</RegisterTitle>
      <Formik
        initialValues={{
          userName: '',
          email: '',
          password: '',
        }}
        validate={validateSchema}
        onSubmit={submitForm}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, touched, values }) => (
          <form onSubmit={handleSubmit}>
            <FormControl>
              <AuthenticationInputLabel
                shrink
                sx={{ '&.Mui-focused': { color: '#FFFFFF' } }}
                htmlFor="userName"
              >
                Account Name
              </AuthenticationInputLabel>
              <AuthenticationBox>
                <AuthenticationInput
                  id="userName"
                  type="userName"
                  value={values.userName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.userName && errors.userName && (
                  <ErrorFormHelperText error>{errors.userName}</ErrorFormHelperText>
                )}
              </AuthenticationBox>
            </FormControl>
            <FormControl>
              <AuthenticationInputLabel
                shrink
                sx={{ '&.Mui-focused': { color: '#FFFFFF' } }}
                htmlFor="email"
              >
                Email
              </AuthenticationInputLabel>
              <AuthenticationBox>
                <AuthenticationInput
                  id="email"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.email && errors.email && (
                  <ErrorFormHelperText error>{errors.email}</ErrorFormHelperText>
                )}
              </AuthenticationBox>
            </FormControl>
            <FormControl>
              <AuthenticationInputLabel
                shrink
                sx={{ '&.Mui-focused': { color: '#FFFFFF' } }}
                htmlFor="password"
              >
                Password
              </AuthenticationInputLabel>
              <AuthenticationBox>
                <AuthenticationInput
                  id="password"
                  type="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.password && errors.password && (
                  <ErrorFormHelperText error>{errors.password}</ErrorFormHelperText>
                )}
              </AuthenticationBox>
            </FormControl>
            <RegisterButton type="submit">Register</RegisterButton>
          </form>
        )}
      </Formik>
      <GoogleLoginBtn {...props} />
    </RegisterInputContainer>
  );
}
